import React from "react";
import { STATUS_COLORS, labelize } from "@/lib/constants";

export default function StatusBadge({ status, testId }) {
  if (!status) return <span className="label-mono">—</span>;
  const cls = STATUS_COLORS[status] || "bg-zinc-800 text-white";
  return (
    <span
      data-testid={testId}
      className={`inline-block px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest border border-black ${cls}`}
    >
      {labelize(status)}
    </span>
  );
}
